import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, isAuthenticated, isLoading, isDev } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg, #005a3e 0%, #004D35 50%, #003d2a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            border: '3px solid rgba(255,255,255,0.2)',
            borderTopColor: '#a8f0c6',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 16px',
          }} />
          <p style={{ color: 'rgba(255,255,255,0.6)', fontFamily: 'sans-serif', fontSize: 14 }}>
            Loading...
          </p>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    if (isDev) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#f9f9f7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            textAlign: 'center',
            background: '#fff',
            padding: '40px 48px',
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            border: '1px solid #e5e7eb',
            maxWidth: 400,
          }}>
            <h2 style={{ fontFamily: 'Georgia, serif', fontSize: 22, color: '#0a1a0f', marginBottom: 12 }}>
              Dev Mode — Sign In Required
            </h2>
            <p style={{ color: '#666', fontFamily: 'sans-serif', fontSize: 14, marginBottom: 24 }}>
              Use the DEV mode selector in the header to log in as a {requiredRole || 'user'}.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                background: '#004D35', color: '#fff',
                padding: '10px 28px', borderRadius: 9999,
                border: 'none', cursor: 'pointer',
                fontWeight: 600, fontSize: 14, fontFamily: 'sans-serif',
              }}
            >
              Go to Home
            </button>
          </div>
        </div>
      );
    }
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    const roleRedirects = {
      advisor: '/advisor-portal',
      admin: '/admin',
    };
    return <Navigate to={roleRedirects[user.role] || '/'} replace />;
  }

  return children;
};

export default ProtectedRoute;
